import { render, staticRenderFns } from "./AddInfo.vue?vue&type=template&id=73fd3282&scoped=true"
import script from "./AddInfo.vue?vue&type=script&lang=js"
export * from "./AddInfo.vue?vue&type=script&lang=js"
import style0 from "./AddInfo.vue?vue&type=style&index=0&id=73fd3282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fd3282",
  null
  
)

export default component.exports